import Link from "next/link";
import type {ReactNode} from "react";
export default function PlayerLink({id,name,team,tournamentId,children}:{id?:number;name:string;team?:string;tournamentId?:number;children?:ReactNode}){
 const params=new URLSearchParams({name});if(team)params.set("team",team);if(tournamentId)params.set("tournament",String(tournamentId));
 return <Link href={id?`/players/${id}`:`/players/resolve?${params}`} className="hover:text-emerald-300 hover:underline">{children??name}</Link>;
}
